<div class="tiime-tabs-header">
  @for (tab of tabs; track $index) {
    <div
      class="tiime-tab-label"
      [class.disabled]="tab.disabled"
      [class.selected]="activeTab() === tab"
      (click)="selectTab(tab)"
    >
      @if (tab.title) {
        <ng-container [ngTemplateOutlet]="tab.title" />
      } @else {
        {{ tab.label }}
      }
    </div>
  }
</div>
<div class="tiime-tabs-content">
  @if (activeTab(); as activeTab) {
    <div [ngTemplateOutlet]="activeTab.content"></div>
  }
</div>
